import { useSelector } from 'react-redux';

/**
 * Whether this author's plan grants unrestricted critique-group hosting.
 *
 * Mirrors the server's `isPaidHost` (api/src/utils/groups/critiqueGroupTier.js):
 * prefer the `canHostCritiqueGroups` account virtual, fall back to the raw
 * product feature. Both reach the client because the Account schema serializes
 * virtuals and the profile populates the plan's product.
 *
 * ADVISORY ONLY. This decides which upgrade prompts to show and nothing else —
 * the server enforces every limit, silently CLAMPS `memberCap` rather than
 * erroring, and may reject a create with UPGRADE_REQUIRED_* even when this says
 * true (e.g. a plan change mid-session). Always handle that error anyway.
 */
export const useCanHostCritiqueGroups = (): {
  canHost: boolean;
  isFree: boolean;
} => {
  const userProfile = useSelector((state: any) => state.user.userProfile);
  const account = userProfile?.account;

  const canHost =
    typeof account?.canHostCritiqueGroups === 'boolean'
      ? account.canHostCritiqueGroups
      : !!account?.product?.features?.canHostCritiqueGroups;

  return { canHost, isFree: !canHost };
};

export default useCanHostCritiqueGroups;
